import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrderEntryRestService } from '../order-entry-rest.service';
import { CancelOrderParameters, OrderCapture } from '../../../domain';

@Injectable()
export class CancelOrderFormService {

  constructor(private orderEntryRestService: OrderEntryRestService) {
  }

  sendCancelOrderRequest(params: CancelOrderParameters): Observable<OrderCapture> {
    return this.orderEntryRestService.sendCancelOrderRequest(params);
  }
}
